export enum ServiceLimitType {
  FLAT = 'flat',
  NUMBER_OF_PIECES = 'number-of-pieces',
  NUMBER_OF_DAYS = 'number-of-days',
}

export enum ServiceInfoPurchaseType {
  WITH_SPOT = 'withSpot',
  ALONE = 'alone',
}

export interface ServicesInfoResponse {
  limits: {
    availableQuantity: number
    maximumQuantity: number
    minimumQuantity: number
    spotMinimumQuantity: number
    spotLimitQuantity: number
    minimumReservationQuantity?: number
    maximumReservationQuantity?: number
    ticketReservationMinimum?: number
    ticketReservationLimit?: number
    ticketSpotMinimum?: number
    ticketSpotLimit?: number
    reservedQuantity: number
    hasLimit: boolean
    serviceGroupLimits: {
      serviceGroupId: number
      hasLimit: boolean
      name: string
      availableQuantity: number
      maximumQuantity: number
      maximumReservationQuantity: number
      minimumReservationQuantity: number
      minimumSpotQuantity: number
      maximumSpotQuantity: number
      reservedQuantity: number
      serviceLimits: Service[]
    }[]
    extraServiceLimits: FeaturedService[]
  }
}

export type FeaturedService = Service & {
  featured: boolean
  image: string
  description: string
}

export interface TimeSchedule {
  availableQuantity: number
  endTime: string
  hasLimit: boolean
  maximumLimitType?: ServiceLimitType
  maximumQuantity: number
  minimumLimitType?: ServiceLimitType
  minimumReservationQuantity: number
  name: string
  price: number
  priceMode: ServicePriceMode
  reservedQuantity: number
  startTime: string
}

export interface Service {
  availableQuantity: number
  dailyTimeSchedules: Record<string, TimeSchedule[]>
  description: string
  featured?: boolean
  globalAvailableQnt?: number
  globalLimit?: number
  globalMaximumQnt?: number
  globalReservedQnt?: number
  groupAvailableQnt?: number
  groupHasLimit?: boolean
  groupLimit?: number
  groupMaximumQnt?: number
  groupReservedQnt?: number
  hasLimit: boolean
  icon: string
  image: string
  maximumLimitType?: ServiceLimitType
  maximumQuantity: number
  minimumLimitType?: ServiceLimitType
  minimumQuantity: number
  name: string
  price: number
  quantity?: number
  reservedQuantity: number
  scheduleType: 'custom' | 'daily' | 'shifted'
  sectors: number[]
  serviceGroupId: number
  serviceGroupName: string
  serviceId: number
  timeSchedules: TimeSchedule[]
}

export interface ServiceGroup {
  serviceGroupId: number
  hasLimit: boolean
  name: string
  maximumQuantity: number
  maximumReservationQuantity: number
  minimumReservationQuantity: number
  minimumSpotQuantity: number
  maximumSpotQuantity: number
  availableQuantity: number
  reservedQuantity: number
  services: Service[]
}

export type GroupIds = number[] | null

export type FormattedServices =
  | Record<
      string,
      {
        sectors: number[]
        id: number
      }
    >
  | undefined

export interface ServiceAvailability {
  global: number
  group: number
  ticket: number
}

export type GroupsWithQuantity = (Omit<ServiceGroup, 'services'> & {
  services: (Service & { quantity?: number })[]
})[]

export enum ServicePriceMode {
  FIXED,
  DAILY,
  TABLE,
  BEDS,
  DAILY_BEDS,
}
